export default __webpack_public_path__ + "static/media/tour-library.eef39d4d.svg";